import React from 'react';
import PropTypes from 'prop-types';
import MyImage from "./MyImage";

ScrollableImageList.propTypes = {};


interface Props {
    childCount: number;
    height: string;
}

function ScrollableImageList(props: Props) {
    const {childCount, height} = props;
    return (
        <div className={"d-flex"} style={{height: height, overflowX: "auto"}}>
            {
                Array.from({length: childCount}, (_, i) => (
                    <MyImage key={i} fileName={`image_${i}.jpg`}/>
                ))
            }
        </div>
    );
}

export default ScrollableImageList;